module.exports = __webpack_public_path__ + "static/img/KOEN-SANCHEZ.a936ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KOEN-SANCHEZ.jpg
// module id = TN5B
// module chunks = 0